<div [dir]="direction">
    <router-outlet></router-outlet>
    <app-loader></app-loader>

    </div> 

